import { Routes } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { ParceiroModule } from '../pages/cad/parceiro/parceiro.module';

export const cadRoutes: Routes = [
  {
    path: 'produto-fornecedor',
    loadChildren: () =>
      import('../pages/cad/produto-fornecedor/produto-fornecedor.module').then(
        (module) => module.ProdutoFornecedorModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'calendario',
    loadChildren: () =>
      import('../pages/cad/calendario/calendario.module').then(
        (module) => module.CalendarioModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "cadastro-generico",
    loadChildren: () =>
      import("../pages/cad/cadastro-generico/cadastro-generico.module").then(
        (module) => module.CadastroGenericoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "ncm",
    loadChildren: () =>
      import("../pages/cad/ncm/ncm.module").then(
        (module) => module.NcmModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "classificacao-tributaria",
    loadChildren: () =>
      import("../pages/cad/classificacao-tributaria/classificacao-tributaria.module").then(
        (module) => module.ClassificacaoTributariaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'fornecedor',
    loadChildren: () =>
      import('../pages/cad/fornecedor/fornecedor.module').then(
        (module) => module.FornecedorModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'pessoa',
    loadChildren: () =>
      import('../pages/cad/pessoa/pessoa.module').then(
        (module) => module.PessoaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'portador',
    loadChildren: () =>
      import('../pages/cad/portador/portador.module').then(
        (module) => module.PortadorModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'cliente',
    loadChildren: () =>
      import('../pages/cad/cliente/cliente.module').then(
        (module) => module.ClienteModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "estacao-trabalho",
    loadChildren: () =>
      import("../pages/cad/estacao-trabalho/estacao-trabalho.module").then(
        (module) => module.EstacaoTrabalhoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "deposito",
    loadChildren: () =>
      import('../pages/cad/deposito/deposito.module').then(
        (module) => module.DepositoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'produto',
    loadChildren: () =>
      import('../pages/cad/produto/produto.module').then(
        (module) => module.ProdutoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'area',
    loadChildren: () =>
      import('../pages/cad/area/area.module').then(
        (module) => module.AreaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "layout-arquivo",
    loadChildren: () =>
      import("../pages/cad/layout-arquivo/layout-arquivo.module").then(
        (module) => module.LayoutArquivoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'configurador-fiscal',
    loadChildren: () =>
      import(
        '../pages/cad/configurador-fiscal/configurador-fiscal.module'
      ).then((module) => module.ConfiguradorFiscalModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'impressora',
    loadChildren: () =>
      import('../pages/cad/impressora/impressora.module').then(
        (module) => module.ImpressoraModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'transportadora',
    loadChildren: () =>
      import('../pages/cad/transportadora/transportadora.module').then(
        (module) => module.TransportadoraModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'cep',
    loadChildren: () =>
      import('../pages/cad/cep/cep.module').then(
        (module) => module.CepModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'cfop',
    loadChildren: () =>
      import('../pages/cad/cfop/cfop.module').then(
        (module) => module.CfopModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'cidade',
    loadChildren: () =>
      import('../pages/cad/cidade/cidade.module').then(
        (module) => module.CidadeModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'familia',
    loadChildren: () =>
      import('../pages/cad/familia/familia.module').then(
        (module) => module.FamiliaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'empresa',
    loadChildren: () =>
      import('../pages/cad/empresa/empresa.module').then(
        (module) => module.EmpresaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'filial',
    loadChildren: () =>
      import('../pages/cad/filial/filial.module').then(
        (module) => module.FilialModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'tipo-veiculo',
    loadChildren: () =>
      import('../pages/cad/tipo-veiculo/tipo-veiculo.module').then(
        (module) => module.TipoVeiculoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'veiculo',
    loadChildren: () =>
      import('../pages/cad/veiculo/veiculo.module').then(
        (module) => module.VeiculoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'local',
    loadChildren: () =>
      import('../pages/cad/local/local.module').then(
        (module) => module.LocalModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'serie',
    loadChildren: () =>
      import('../pages/cad/serie/serie.module').then(
        (module) => module.SerieModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "centro-custo",
    loadChildren: () =>
      import("../pages/cad/centro-custo/centro-custo.module").then(
        (module) => module.CentroCustoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "motorista",
    loadChildren: () =>
      import("../pages/cad/motorista/motorista.module").then(
        (module) => module.MotoristaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'parceiro',
    loadChildren: () =>
      import('../pages/cad/parceiro/parceiro.module').then(
        (module) => module.ParceiroModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'indice',
    loadChildren: () =>
      import('../pages/bas/indice/indice.module').then(
        (module) => module.IndiceModule
      ),
    canActivate: [AuthGuard],
  }
];
